<template>
    <div class="image">
        <img :src="src" alt="" v-show="loaded" class="image_image" @load="loaded = true" :style="style">
    </div>
</template>

<script>
    export default {
        props: {
            alt: {default: ''},
            src: {required: true},
            position: {default: 'top center'},
        },
        data() {
            return {
                loaded: false,
            }
        },
        computed: {
            style() {
                return {
                    "object-position": this.position,
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";

.image {
    background-color: $color-betano;
    height: 100%;
    width: 100%;

    img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        animation: .5s ease-in-out fade;
    }
}

@keyframes fade {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>

